/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="79.13" height="94.33" viewBox="0 0 79.13 94.33" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <g>
          <path d="M77.56,105.73v0Z" transform="translate(-38 -30)" fill="#0d5383" fillRule="evenodd"/>
          <polygon points="40.81 63.97 40.81 75.72 38.31 75.72 38.31 63.97 40.81 63.97" fill="#0e497b"/>
          <path d="M77.56,94v0Z" transform="translate(-38 -30)" fill="#0d5383" fillRule="evenodd"/>
          <path d="M77.56,73.79a1.26,1.26,0,0,1,1.25,1.12V94a1.25,1.25,0,0,1-2.49.12V75A1.25,1.25,0,0,1,77.56,73.79Z" transform="translate(-38 -30)" fill="#0e497b"/>
          <path d="M77.56,105.73v0Z" transform="translate(-38 -30)" fill="#0d5383" fillRule="evenodd"/>
          <polygon points="40.81 63.97 40.81 75.72 38.31 75.72 38.31 63.97 40.81 63.97" fill="#0e497b"/>
          <path d="M69.48,105.73v0Z" transform="translate(-38 -30)" fill="#0d5383" fillRule="evenodd"/>
          <polygon points="32.73 63.97 32.73 75.72 30.23 75.72 30.23 63.97 32.73 63.97" fill="#0e497b"/>
          <g>
            <path d="M77.57,30a8.59,8.59,0,1,0,8.59,8.59A8.59,8.59,0,0,0,77.57,30Zm0,2.5a6.09,6.09,0,1,1-6.09,6.09A6.09,6.09,0,0,1,77.57,32.5Z" transform="translate(-38 -30)" fill="#0e497b"/>
            <g>
              <line x1="39.56" y1="63.97" x2="39.56" y2="75.73" fill="none"/>
              <polygon points="40.81 63.97 40.81 75.72 38.31 75.72 38.31 63.97 40.81 63.97" fill="#0e497b"/>
            </g>
            <g>
              <line x1="39.56" y1="45.04" x2="39.56" y2="63.97" fill="none"/>
              <path d="M77.56,73.79a1.26,1.26,0,0,1,1.25,1.12V94a1.25,1.25,0,0,1-2.49.12V75A1.25,1.25,0,0,1,77.56,73.79Z" transform="translate(-38 -30)" fill="#0e497b"/>
            </g>
            <g>
              <line x1="39.56" y1="63.97" x2="39.56" y2="75.73" fill="none"/>
              <polygon points="40.81 63.97 40.81 75.72 38.31 75.72 38.31 63.97 40.81 63.97" fill="#0e497b"/>
            </g>
            <g>
              <line x1="31.48" y1="63.97" x2="31.48" y2="75.73" fill="none"/>
              <polygon points="32.73 63.97 32.73 75.72 30.23 75.72 30.23 63.97 32.73 63.97" fill="#0e497b"/>
            </g>
            <path d="M102.88,40.11a4.28,4.28,0,0,1,2.75,7.57l-.19.16L86.9,60.65V94a1.25,1.25,0,0,1-1.12,1.24h-.13A1.26,1.26,0,0,1,84.4,94.1V60a1.27,1.27,0,0,1,.43-1l.11-.08,19-13.15a1.79,1.79,0,0,0-1.09-3.21,1.85,1.85,0,0,0-.74.15l-.17.09-15.7,9a1.23,1.23,0,0,1-.49.16H69.48a1.25,1.25,0,0,1-.51-.1l-.11-.06-15.71-9a1.73,1.73,0,0,0-.9-.24,1.79,1.79,0,0,0-1.79,1.79A1.77,1.77,0,0,0,51,45.68l.12.1L70.19,59a1.23,1.23,0,0,1,.53.89V94a1.25,1.25,0,0,1-2.49.13V60.65L49.63,47.8A4.27,4.27,0,0,1,48,44.64V44.4a4.29,4.29,0,0,1,4.29-4.29,4.25,4.25,0,0,1,1.93.45l.22.12,15.41,8.86h15.5l15.41-8.85a4.18,4.18,0,0,1,1.9-.58Z" transform="translate(-38 -30)" fill="#0e497b"/>
            <g>
              <line x1="47.65" y1="63.97" x2="47.65" y2="75.73" fill="none"/>
              <polygon points="48.9 63.97 48.9 75.72 46.4 75.72 46.4 63.97 48.9 63.97" fill="#0e497b"/>
            </g>
            <path d="M64.79,111v2.5H40.5v10.85H38v-12.1A1.24,1.24,0,0,1,39.12,111H64.79Z" transform="translate(-38 -30)" fill="#ffb81c"/>
            <path d="M115.88,116.14a1.25,1.25,0,0,1,1.24,1.12v7.07h-2.5v-5.69H90.33v-2.5Z" transform="translate(-38 -30)" fill="#ffb81c"/>
            <path d="M90.33,104.09a1.26,1.26,0,0,1,1.25,1.12v19.12h-2.5V106.59H66v17.74h-2.5v-19a1.26,1.26,0,0,1,1.12-1.25H90.33Z" transform="translate(-38 -30)" fill="#ffb81c"/>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'OnePersonOnChampionshipPodiumFirstPlaceIcon';

export default Icon;
